import { PalletGroupDescription } from "@cnx/common";
import { Box, Flex, Text } from "@mantine/core";
import IconItem from "components/IconItem";
import { useTranslation } from "react-i18next";
import { selectIconByStatus } from "utils/activities";

interface ShortActivityProps {
  palletGroupDescription: PalletGroupDescription[];
}

const ShortActivityBlock: React.FC<ShortActivityProps> = ({
  palletGroupDescription,
}) => {
  const { t } = useTranslation("shippingManagement");

  return (
    <Box>
      {palletGroupDescription.map(
        ({ activityCode, palletInfo, stops }, index) => {
          if (palletInfo.length === 0) {
            return null;
          }

          return (
            <IconItem icon={selectIconByStatus(activityCode)} key={index}>
              {stops} {t("stop", { count: stops })}, {palletInfo}
            </IconItem>
          );
        }
      )}
    </Box>
  );
};

export default ShortActivityBlock;
